import homePage from "../views/homePage.vue";
import textPage from "../views/textPage.vue";

export default [
  {
    path: "/",
    name: "home",
    component: homePage,
  },
  {
    path: "/text",
    name: "text",
    component: textPage,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];